import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { VanityLinkModal } from 'src/app/pages/starterDashboardV2/shared/components';
import { VanityModalStateContextProvider } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { CopyLinkButton } from './components/CopyLinkButton/index_new';
import { EditURLButton } from './components/EditURLButton';
import { useShareUrl } from './hooks/useShareUrl/index_new';

export function ShareUrl(): JSX.Element {
	const { data, actions } = useShareUrl();
	const { translate } = useI18n();
	const {
		data: { petition },
		actions: { refreshData },
	} = useStarterDashboardV2PageData();

	return (
		<div data-testid="share-url" className="flex flex-col gap-2 rounded-small bg-background-overlay p-2">
			<div className="rounded-small bg-background-base px-4 py-2">
				<Text className="text-size-body-xs">Your unique Link</Text>
				<div className="flex flex-row items-center justify-between">
					<Text
						aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.short_url_aria_label')}
						data-testid="copylink-input"
						className="max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap text-size-body-small-bold"
					>
						{data.shareUrl}
					</Text>
					{data.canEditUrl && (
						<VanityModalStateContextProvider>
							<VanityLinkModal
								petitionId={petition.id}
								petitionSlug={petition.slug}
								displayedSignatures={petition.signatureState.signatureCount.displayed}
								data-qa="vanity-link-modal"
								onClose={refreshData}
								trigger={<EditURLButton data-qa="edit-url-button" onEditUrl={actions.onEditUrl} />}
							/>
						</VanityModalStateContextProvider>
					)}
				</div>
			</div>
			<div>
				<CopyLinkButton shareUrl={data.shareUrl} />
			</div>
		</div>
	);
}
